<div class="danger-dialog">
  <div class="danger-banner">
    <mat-icon>warning</mat-icon>
    <span>THIS CANNOT BE UNDONE</span>
    <mat-icon>warning</mat-icon>
  </div>

  <h2 mat-dialog-title>{{ data.title }}</h2>

  <mat-dialog-content>
    <ul class="warning-list">
      @for (line of data.warnings; track line) {
        <li>{{ line }}</li>
      }
    </ul>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="confirm-field">
      <mat-label>Type "{{ data.confirmText }}" ({{ data.confirmLabel }}) to unlock</mat-label>
      <input matInput [(ngModel)]="typedValue" autocomplete="off" spellcheck="false">
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button (click)="dialogRef.close(false)">
      Cancel
    </button>

    <button mat-raised-button color="warn" [disabled]="!isUnlocked" (click)="confirm()">
      <mat-icon>delete_forever</mat-icon>
      Permanently Delete
    </button>
  </mat-dialog-actions>
</div>
